// src/hooks/useJobSuggestions.js
// Jobsite suggestions for the job pickers (David, 10/29): jobs where the phone
// is ("here", within 400 ft), close by ("nearby", within 1/2 mile), and the
// Labor Board jobs this week of the person who will have the tool. See
// ngc-tracker-api routes/locationSuggestions.js.
import { useEffect, useState } from 'react';
import { getLocationSuggestions } from '../services/api';
import { getPosition } from '../utils/gps';

const EMPTY = { here: [], nearby: [], assigned: [], at_shop: false, have_gps: false };

export default function useJobSuggestions(forWorkerId) {
  const [state, setState] = useState({ loading: true, ...EMPTY });

  useEffect(() => {
    let alive = true;
    setState({ loading: true, ...EMPTY });
    (async () => {
      const gps = await getPosition();
      try {
        const res = await getLocationSuggestions({
          lat: gps?.lat, lng: gps?.lng, for_worker_id: forWorkerId || undefined,
        });
        if (alive) setState({ loading: false, ...EMPTY, ...res.data });
      } catch {
        if (alive) setState({ loading: false, ...EMPTY });
      }
    })();
    return () => { alive = false; };
  }, [forWorkerId]);

  return state;
}
